import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { SignedInvoiceDetailPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DetailPortal from 'modules/expenses/components/DetailPortal/DetailPortal'
import ExpenseFileViewer from 'modules/expenses/components/FileViewer/Viewer'
import Loading from 'modules/layout/components/Page/Loading'

import InvoiceForm from './Components/Form/Form'
import Navigator from './Components/Navigator'
import { convertInvoiceFileToUploadFile } from './utils'

interface SignedInvoiceDetailProps {
  invoiceId: number
}

const SignedInvoiceDetail = ({ invoiceId }: SignedInvoiceDetailProps) => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()
  const mainLegalEntity = company.legalEntities.find((legalEntity) => legalEntity.main)

  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.expenses.signedInvoices.fullPath())
  }

  const { data, loading } = useQuery(SignedInvoiceDetailPageDocument, {
    variables: {
      ids: [invoiceId],
      signedForOrganization: 'aeat',
      receiverLegalEntityId: Number(mainLegalEntity?.id),
    },
    skip: !mainLegalEntity?.id,
  })

  const invoice = data?.expenses.signedInvoicesConnection.nodes[0]
  const expensable = invoice?.parentExpense?.expensable

  if (loading)
    return (
      <DetailPortal onClose={onClose}>
        <Loading />
      </DetailPortal>
    )
  if (!invoice || !expensable) return <NotFound />
  const invoiceFile = convertInvoiceFileToUploadFile(invoice.parentSignedDocument?.files[0])
  const invoiceIdsList =
    data?.expenses.invoiceIds.map(({ id }) => ({ id })).sort((a, b) => a.id - b.id) || []

  return (
    <DetailPortal onClose={onClose}>
      <Box flexDirection="row" height="full" width="full">
        <ExpenseFileViewer currentFile={invoiceFile} files={invoiceFile ? [invoiceFile] : []} />

        <Box background="grey000White" minWidth="s600">
          <Navigator invoice={invoice} expensable={expensable} invoiceIdsList={invoiceIdsList} />
          <InvoiceForm invoice={invoice} />
        </Box>
      </Box>
    </DetailPortal>
  )
}

export default SignedInvoiceDetail
